export namespace DocIssuanceNS {
  export interface DocIssuanceRequest {
    selectionReferenceDetails: SelectionReferenceDetail[];
    paxSelections?: PaxSelection[];
    optionGroups?: OptionGroup[];
    infantOrAdultAssociationType?: string;
    otherCompoundOptions?: OtherCompoundOption[];
  }

  export interface SelectionReferenceDetail {
    type: string;
    value: number;
  }

  export interface PaxSelection {
    type: string;
    value: number;
  }

  export interface OptionGroup {
    indicator: string;
    subCompoundOptions: SubCompoundOption[];
    overrideAlternativeDate?: OverrideAlternativeDate;
  }

  export interface SubCompoundOption {
    attributeType: string;
    attributeDescription?: string;
  }

  export interface OverrideAlternativeDate {
    businessSemantic: string;
    dateTime: DateTime;
  }

  export interface DateTime {
    year: string;
    month: string;
    day: string;
  }

  export interface OtherCompoundOption {
    attributeType: string;
    attributeDescription: string;
  }

  export interface DocIssuanceResponse {
    statusCode: string;
    errorMessage: ErrorMessage;
  }

  export interface ErrorMessage {
    errorDescription: ErrorDescription;
    errorDetails: ErrorDetails;
  }

  export interface ErrorDescription {
    freeText: string[];
    freeTextSubjectQualifier: string;
    freeTextSource: string;
    freeTextEncoding: string;
  }

  export interface ErrorDetails {
    errorCode: string;
    errorCategory: string;
    errorCodeOwner: string;
  }

  export const enum DocIssuanceType {
    'DocTicket' = 'DocTicket',
    'DocEmd' = 'DocEmd',
    'DocEmdAndTicket' = 'DocEmdAndTicket',
  }
}
